//import logo from './logo.svg';
//import './App.css';
import React, {useEffect,useState} from 'react';


import ReactDOM from 'react-dom'
//import {Container, AppBar, Typography, Grow, Grid} from '@material-ui/core';
import { styled, createTheme, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import MuiDrawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';
import MuiAppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Moment from 'moment'
import Badge from '@mui/material/Badge';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MyLink from '@mui/material/Link';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Button from '@mui/material/Button';
import ChartsEmbedSDK from "@mongodb-js/charts-embed-dom";
import Card from '@mui/material/Card';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';

import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import { mainListItems, secondaryListItems } from '../listItems';

import LineChart from '../lineChart';
import UserList from '../userList';
import Odors from '../odorTracker';
import MapDevice from '../mapDevice';
//import LeafMap from '../leafMap';
import Legend from '../Legend';
import logo from '../logos/JustAirLogo1.png'

import {useDispatch, useSelector} from 'react-redux'
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Link,
  useNavigate
} from "react-router-dom";

//import memories from './memories.png'
import { logout, reset } from '../features/auth/authSlice'
import {getProjects,getProject} from '../features/projects/projectSlice'
import {getDevices,createDevices} from '../features/devices/deviceSlice'


//import memories from './memories.png'

import useStyles from '../styles'

const theme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#29ABE2',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});


const Admin = () => {

  const navigate = useNavigate()
  const dispatch = useDispatch()

  const { user } = useSelector((state) => state.auth)
  const { projects } = useSelector((state) => state.project)
  const { devices } = useSelector((state) => state.device)


  const [value, setValue] = React.useState(0);
  function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`simple-tabpanel-${index}`}
        aria-labelledby={`simple-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box sx={{ p: 3 }}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }


  function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }

  const handleChange = (event, newValue) => {
   setValue(newValue);
 };


   useEffect(() => {


     if (!user) {
       navigate('/login')
     }

     dispatch(getProjects())
      dispatch(getDevices())

     return () => {
       dispatch(reset())
     }
   }, [user, navigate])


   console.log(projects)
   console.log(devices)
    const onLogout = () => {
      dispatch(logout())
      dispatch(reset())
      navigate('/')

    }


       const projectNav = (data) => {
         //console.log(data)
         dispatch(getProject(data))
         navigate('/project')

       }


      const devEdit = (data) => {
        console.log(data)
        localStorage.setItem('deviceEdit', JSON.stringify(data))

        navigate('/EditDevice')

      }



function Copyright(props) {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <MyLink color="inherit" href="https://justair.co/" target="_blank">
        JustAir Solutions
      </MyLink>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

const drawerWidth = 240;

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  zIndex: theme.zIndex.drawer + 1,
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
  ({ theme, open }) => ({
    '& .MuiDrawer-paper': {
      position: 'relative',
      whiteSpace: 'nowrap',
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
      boxSizing: 'border-box',
      ...(!open && {
        overflowX: 'hidden',
        transition: theme.transitions.create('width', {
          easing: theme.transitions.easing.sharp,
          duration: theme.transitions.duration.leavingScreen,
        }),
        width: theme.spacing(7),
        [theme.breakpoints.up('sm')]: {
          width: theme.spacing(9),
        },
      }),
    },
  }),
);

const mdTheme = createTheme({
  palette: {
    primary: {
      // light: will be calculated from palette.primary.main,
      main: '#1572A1',
      // dark: will be calculated from palette.primary.main,
      // contrastText: will be calculated to contrast with palette.primary.main
    },
    secondary: {
      light: '#0066ff',
      main: '#0044ff',
      // dark: will be calculated from palette.secondary.main,
      contrastText: '#ffcc00',
    },
    // Used by `getContrastText()` to maximize the contrast between
    // the background and the text.
    contrastThreshold: 3,
    // Used by the functions below to shift a color's luminance by approximately
    // two indexes within its tonal palette.
    // E.g., shift from Red 500 to Red 300 or Red 700.
    tonalOffset: 0.2,
  },
});;


  const [open, setOpen] = React.useState(false);
  const toggleDrawer = () => {
    setOpen(!open);
  };

  return (
    <ThemeProvider theme={mdTheme}>
      <Box sx={{ display: 'flex' }}>
        <CssBaseline />
        <AppBar position="absolute" open={open}>
          <Toolbar
            sx={{
              pr: '24px', // keep right padding when drawer closed
            }}
          >
            <IconButton
              edge="start"
              color="inherit"
              aria-label="open drawer"
              onClick={toggleDrawer}
              sx={{
                marginRight: '36px',
                ...(open && { display: 'none' }),
              }}
            >
              <MenuIcon />
            </IconButton>
            <Typography
              component="h1"
              variant="h6"
              color="white"
              noWrap
              sx={{ flexGrow: 1 }}
            >
              RACCE Air
            </Typography>

            {user ? (<>
            <Button color="inherit"   onClick={() => { onLogout()}}>Logout</Button></>
              ) :
              (<>
              <Button color="inherit"   onClick={() => { navigate("/login");}}>Login</Button>
              <Button color="inherit"  onClick={() => { navigate("/register");}}>Register</Button> </>)
            }


          </Toolbar>
        </AppBar>
        <Drawer variant="permanent" open={open}>
          <Toolbar
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'flex-end',
              px: [1],
            }}
          >
            <IconButton onClick={toggleDrawer}>
              <ChevronLeftIcon />
            </IconButton>
          </Toolbar>
          <Divider />
          <List>{mainListItems}</List>
          <Divider />

        </Drawer>
        <Box
          component="main"
          sx={{
            backgroundColor: (theme) =>
              theme.palette.mode === 'light'
                ? theme.palette.grey[100]
                : theme.palette.grey[900],
            flexGrow: 1,
            height: '100vh',
            overflow: 'auto',
          }}
        >

          <Toolbar />







                <Grid container  alignItems="center" justifyContent="center" spacing={2} xs={12} md={12} lg={12}  direction="row">
                <Grid item xs={12} >


                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                     <Tabs value={value} onChange={handleChange} aria-label="basic tabs example">
                       <Tab label="Projects" {...a11yProps(0)} />

                       <Tab label="Devices" {...a11yProps(1)} />

                      </Tabs>
                  </Box>

                    <TabPanel value={value} index={0}>

                     <Typography sx={{ fontSize: 34 }}  gutterBottom>
                      Create a Project
                     </Typography>

                     <Typography sx={{ fontSize: 16 }}  gutterBottom>
                    Set up your project to begin your mobile air monitoring study
                     </Typography>

                   <Button size="small" onClick={() => {

                      navigate("/createProject");
                    }}>Create Project</Button>


                    <Grid container sx={{ m: 1 }} spacing={1} xs={12} direction="row">

  {projects.map( ( project ) => (

                <Grid item xs={12} lg={3} sx={{ height:1 }}>
                  <Card sx={{ height:1 }}>
                     <CardContent sx={{ height:'175px' }}>
                       <Typography sx={{ fontSize: 40 }}  gutterBottom>
                        {project.projectName}
                       </Typography>
                       <Typography variant="h5" component="div">

                       </Typography>
                       <Typography sx={{ fontSize: 20  }} color="text.secondary">
                         {Moment(project.startDate).format('MM/DD/YYYY')}
                       </Typography>


                     </CardContent>
                     <CardActions>
                       <Button size="small" onClick={() => {

                        projectNav(project);
                        }}>View Project</Button>


                     </CardActions>
                   </Card>
                  </Grid>



              ))}
</Grid>










              </TabPanel>

                <TabPanel value={value} index={1}>

                <Button size="small" onClick={() => {

                   navigate("/createDevice");
                 }}>Add Device</Button>







                         <Table size="medium">
                           <TableHead>
                             <TableRow>
                               <TableCell>Device ID</TableCell>
                               <TableCell>Active</TableCell>
                                  <TableCell>Edit</TableCell>

                             </TableRow>
                           </TableHead>
                           <TableBody>
                              {devices.map( ( devs ) => (

                                <TableRow key={devs.device_ID} >
                                   <TableCell>{devs.device_ID}</TableCell>
                                 <TableCell>{devs.active.toString()}</TableCell>



                                    <TableCell>
                                    <Button size="small" variant="contained"  onClick={() => {

                                          devEdit(devs);
                                     }} >
                                     Edit Device
                                    </Button>
                                      </TableCell>
                                 </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                          </TabPanel>


                  </Grid>

                    </Grid>








              <Grid item xs={12}>
                <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                    <Copyright sx={{ pt: 4 }} />
                </Paper>
              </Grid>
              </Box>
            </Box>



    </ThemeProvider>
  );



}


export default Admin;
